import { UserAuth } from 'client/voladeum/auth/types';

export const auth_default: UserAuth = { login: '', password: '' };
